var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "member-bar" },
    [
      _vm.member
        ? [
            _c("a-icon", {
              staticClass: "member-icon",
              attrs: { type: "crown" },
            }),
            _c("span", { staticClass: "member-name" }, [
              _vm._v(_vm._s(_vm.member.contacts || _vm.member.cardNo)),
            ]),
            _c("span", { staticClass: "member-level" }, [
              _vm._v(_vm._s(_vm.member.levelName || "会员")),
            ]),
            _c("a-icon", {
              staticClass: "member-clear",
              attrs: { type: "close", title: "清除会员（散客）" },
              on: {
                click: function ($event) {
                  return _vm.$emit("clear")
                },
              },
            }),
          ]
        : [
            _c("a-input-search", {
              ref: "searchInput",
              attrs: {
                placeholder: "扫会员码 / 输入手机号、姓名、卡号定位会员",
                enterButton: "定位会员",
              },
              on: { search: _vm.onSearch },
              model: {
                value: _vm.keyword,
                callback: function ($$v) {
                  _vm.keyword = $$v
                },
                expression: "keyword",
              },
            }),
            _c("span", { staticClass: "guest-tip" }, [_vm._v("当前散客")]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }